import React, { FC } from "react";

import { useLabels } from "../../contexts/labels";
import { MaterialType } from "../../types/materials";
import { renameFields } from "../../utils/object";
import { otherMaterial } from "../forms/forms-fields/materials-form-fields";
import { ExhibitionFinder, ExhibitionFinderProps } from "./exhibition-finder";

export interface ExhibitionFinderSectionProps {
  items: Queries.ExhibitionCardDataFragment[];
}

export const ExhibitionFinderSection: FC<ExhibitionFinderSectionProps> = ({
  items: exhibitions,
}) => {
  const { labels: stringLabels } = useLabels();

  const fieldsToRename: Record<keyof ExhibitionFinderProps["labels"], string | null> = {
    materials: "forms-materials",
    [MaterialType.Wood]: "materials-wood",
    [MaterialType.Stone]: "materials-stone",
    [MaterialType.Glass]: "materials-glass",
    [MaterialType.Materia]: "materials-materia",
    [MaterialType.Metal]: "materials-metal",
    [otherMaterial]: "materials-other",
    "exhibition-card-location": null,
    "exhibitions-grid-empty-state": null,
    "exhibition-finder-header-filter": null,
    "exhibition-finder-panel-clear-filters": null,
    "exhibition-finder-panel-apply-filters": null,
    "exhibition-finder-panel-option-all": null,
    "exhibition-finder-panel-location": null,
    "exhibition-finder-panel-future-or-ongoing-exhibitions": null,
    "exhibition-finder-panel-past-exhibitions": null,
    "exhibition-finder-panel-search": null,
  };

  const labels = renameFields(stringLabels, fieldsToRename) as ExhibitionFinderProps["labels"];

  return (
    <ExhibitionFinder
      filterSearchParamKey="filter-exhibitions"
      exhibitions={exhibitions}
      labels={labels}
    />
  );
};
